import { render, staticRenderFns } from "./deptNew.vue?vue&type=template&id=2a3bab68&scoped=true&"
import script from "./deptNew.vue?vue&type=script&lang=js&"
export * from "./deptNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3bab68",
  null
  
)

export default component.exports